import {fenceCreatorQualification,type CreatorQualifier} from './creator-qualification';
export type {CreatorQualifier} from './creator-qualification';
/** A compiled local owner, not evidence of an applicable Native/Studio operating model. */
export function createCreatorQualificationOwner(){
 let model:CreatorQualifier|undefined,generation=0,disposed=false;
 const unavailable=():never=>{throw Error('creator_program_unavailable');};
 return {
  replace(next?:CreatorQualifier){if(disposed)unavailable();generation++;model=next;},
  acquire(){
   const pinned=model,version=generation;let closed=false,failed=false;
   const current=()=>!disposed&&!closed&&!failed&&generation===version;
   const qualify:CreatorQualifier|undefined=pinned?context=>{
    if(!current())return unavailable();
    try{
     const accept=(value:Awaited<ReturnType<CreatorQualifier>>)=>{const proof=fenceCreatorQualification(value,current);if(!proof.current())return unavailable();return proof;};
     const value=pinned(context);
     return value instanceof Promise?value.then(accept).catch(error=>{failed=true;throw error;}):accept(value);
    }catch(error){failed=true;throw error;}
   }:undefined;
   return Object.freeze({qualify,close(){closed=true;}});
  },
  close(){disposed=true;generation++;model=undefined;}
 };
}
/** Deployment code statically installs an independently established model before application construction.
 * The application installs its selected local composition before acquiring it; Portal RPC/JSON never supplies a qualifier. */
export const compiledCreatorQualification=createCreatorQualificationOwner();
